var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewSingout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.188a.555.555 0 01-.563.562H2.25A2.221 2.221 0 010 8.5v-6C0 1.258.984.25 2.25.25h1.688A.57.57 0 014.5.813a.555.555 0 01-.563.562H2.25c-.633 0-1.125.516-1.125 1.125v6A1.11 1.11 0 002.25 9.625h1.688a.57.57 0 01.562.563zm7.336-5.063L8.859 1.937c-.21-.234-.562-.234-.796-.023-.235.211-.235.563-.024.797l2.086 2.227H4.289a.55.55 0 00-.539.562c0 .328.234.563.54.563h5.812l-2.11 2.25c-.21.234-.21.585.024.796.14.094.28.141.398.141.14 0 .281-.047.399-.164l2.976-3.188a.515.515 0 00.047-.773z",
    fill: "currentColor"
  })));
}
export default SvgPreviewSingout;